module.exports = __webpack_public_path__ + "72a1572aa79543efeffed14e49bdfdef.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/header-logo.png
 ** module id = 569
 ** module chunks = 0
 **/